"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagNameInput = exports.TagNameReadonlyInput = void 0;
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const theme_1 = require("../../components/theme");
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const highlighter_1 = require("../../services/util/highlighter");
const key_binding_1 = require("../../services/util/key.binding");
const tag_name_input_style_1 = require("./tag.name.input.style");
(0, theme_1.addStyles)(tag_name_input_style_1.Style);
exports.TagNameReadonlyInput = {
    view(ctrl) {
        const tag = ctrl.tag;
        var attributes = {
            className: tag_name_input_style_1.CSS.link,
            onclick: (_) => ctrl.zoomToTag(),
        };
        const timeString = services_1.Services.DateTime.formatDateTime(tag.updatedAt);
        var tagNameChildren = tag.name;
        const filterValue = ctrl.getTagFilterValue();
        if (filterValue != null && filterValue.length > 0) {
            tagNameChildren = highlighter_1.Highlighter.highlight(tag.name, filterValue).parts.map((part) => (0, mithril_1.m)('span', { className: part.highlighted ? tag_name_input_style_1.CSS.filterMatch : undefined }, part.content));
        }
        return (0, mithril_1.m)('div', attributes, [
            (0, mithril_1.m)('span', { className: tag_name_input_style_1.CSS.title, title: tag.name }, tagNameChildren),
            (0, mithril_1.m)('div', { className: tag_name_input_style_1.CSS.date, title: (0, index_1.Translate)(index_1.T.LAST_UPDATED_AT, { timeString }) }, timeString),
        ]);
    },
};
exports.TagNameInput = {
    view(ctrl, autoCompleteMenu) {
        const KeyEvents = {
            [key_binding_1.KeyCode.ESCAPE]: () => ctrl.cancelEdit(),
            [key_binding_1.KeyCode.ENTER]: () => ctrl.acceptEdit(),
        };
        const tagNameChildren = (0, mithril_1.m)('input', {
            className: tag_name_input_style_1.CSS.linkEditable,
            spellcheck: false,
            value: ctrl.getInputValue(),
            onkeyup: key_binding_1.KeyCode.bind(KeyEvents),
            oninput: (e) => ctrl.updateEdit(e.target.value),
            oncreate: (vnode) => exports.TagNameInput.startEdit(vnode, ctrl),
            onfocus: () => ctrl.getInputState().setFocused(true),
            onblur: () => ctrl.getInputState().setFocused(false),
        });
        const acceptButton = image_button_1.ImageButton.view(icons_1.MaterialIcon.CHECK, {
            type: 'button',
            onclick: (e) => {
                e.stopPropagation();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                ctrl.acceptEdit();
            },
        });
        const cancelButton = image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            type: 'button',
            onclick: (e) => {
                e.stopPropagation();
                ctrl.cancelEdit();
            },
        });
        return (0, mithril_1.m)('div', { className: tag_name_input_style_1.CSS.container }, [
            tagNameChildren,
            autoCompleteMenu.view(),
            acceptButton,
            cancelButton,
        ]);
    },
    startEdit(vnode, ctrl) {
        var _a;
        const element = vnode.dom;
        const tagCard = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
        if (!tagCard) {
            services_1.Logger.error(`Cannot find Tag Card of ${element}`);
            return;
        }
        const handleClickAway = () => {
            ctrl.tagCard = tagCard;
            ctrl.cancelEdit();
        };
        services_1.Services.FocusAway.from(tagCard, handleClickAway);
        element.focus();
        element.select();
    },
};
//# sourceMappingURL=tag.name.input.js.map